<app-header></app-header>
<router-outlet></router-outlet>
<!-- <app-footer *ngIf="flag"></app-footer> -->
<app-footer></app-footer>
<button class="btn btn-info btn-lg gail-cautions" (click)="openDialog(false)">GAIL GAS Cautions</button>

<a href="#" id="back-to-top" title="Back to top" style="margin-right: -10px;">&uarr;</a>